var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bereikt title"},[_c('ogt-video',{ref:"video",attrs:{"src":"/static/video/bereikt.mp4","poster":"/static/video/bereikt-poster.jpg"}}),_vm._v(" "),_c('h1',[_vm._v("Dit hebben we bereikt in 2020")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }